import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  sendContactRequest: ['data'],
  sendContactSuccess: ['data'],
  sendContactError: ['error'],

  sendNewsletterRequest: ['data'],
  sendNewsletterSuccess: ['data'],
  sendNewsletterError: ['error'],
});

const INITIAL_STATE = Immutable({
  data: {},
  error: {},
  isLoading: false,
  newsletter: {},
});

const sendContactRequest = (state = INITIAL_STATE) => state.merge({ isLoading: true, error: {} });
const sendContactSuccess = (state = INITIAL_STATE, { data }) => state.merge({ data, isLoading: false });
const sendContactError = (state = INITIAL_STATE, { error }) => state.merge({ error, isLoading: false });

const sendNewsletterRequest = (state = INITIAL_STATE) => state.merge({ isLoading: true });
const sendNewsletterSuccess = (state = INITIAL_STATE, { data }) => state.merge({ ...data, isLoading: false });
const sendNewsletterError = (state = INITIAL_STATE, { error }) => state.merge({ error, isLoading: false });

export default createReducer(INITIAL_STATE, {
  [Types.SEND_CONTACT_REQUEST]: sendContactRequest,
  [Types.SEND_CONTACT_SUCCESS]: sendContactSuccess,
  [Types.SEND_CONTACT_ERROR]: sendContactError,

  [Types.SEND_NEWSLETTER_REQUEST]: sendNewsletterRequest,
  [Types.SEND_NEWSLETTER_SUCCESS]: sendNewsletterSuccess,
  [Types.SEND_NEWSLETTER_ERROR]: sendNewsletterError,
});
